<template>
  <div class="unlimited-texts">
    <section class="text-card" v-for="(textInfo, i) in textBooks" :key="i">
      <div class="text-card__photo">
        <img :src="textInfo.img_url" alt="">
      </div>
      <div class="text-card__body text-card-body">
        <h2 class="text-card-body__ttl">{{textInfo.name_book}}</h2>
        <p class="text-card-body__author">著者：<span>{{textInfo.author}}</span></p>
        <p class="text-card-body__price">紙の本の価格：<span>￥{{textInfo.price_jp_book}}</span></p>
        <p class="text-card-body__abc-price">abceed版価格(単品販売)：<span>￥{{textInfo.price_jp}}</span></p>
      </div>
    </section>
  </div>
</template>

<script>
  export default {
    title: 'unlimited教材一覧',
    headerTitle: 'unlimited教材一覧',
    headerType: 'historyBack',
    resetScrollView: true,
    created() {
      this.$store.dispatch("getUnlimitedRanking");
    },
    computed: {
      textBooks() {
        return this.$store.getters.unlimitedBooks;
      }
    }
  }
</script>

<style scoped lang="scss">

.unlimited-texts {
  width: 800px;
  margin: 0 auto;
  background-color: #fff;
  @media screen and (max-width: 768px){
    width: auto;
  }
}

.text-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 25px 30px;
  border-bottom: 1px solid #ebebeb;
  @media screen and (max-width: 768px){
    padding: 15px;
  }
  &__photo {
    width: 110px;
    @media screen and (max-width: 768px){
      width: 80px;
    }
    img {
      width: 100%;
    }
  }
  &__body {
    width: calc(100% - 110px);
    padding: 0 0 0 60px;
    @media screen and (max-width: 768px){
      width: calc(100% - 80px);
      padding: 0 0 0 20px;
    }
  }
}

.text-card-body {
  text-align: left;
  &__ttl {
    font-weight: bold;
    line-height: 1.3;
    margin-bottom: 10px;
    font-size: 18px;
    @media screen and (max-width: 768px){
      font-size: 14px;
    }
  }
  &__author {
    font-size: 16px;
    @media screen and (max-width: 768px){
      font-size: 14px;
    }
  }
  &__price {
    font-size: 16px;
    @media screen and (max-width: 768px){
      font-size: 14px;
    }
  }
  &__abc-price {
    font-size: 16px;
    @media screen and (max-width: 768px){
      font-size: 14px;
    }
  }
}


</style>



// WEBPACK FOOTER //
// src/components/campainPage/unlimited/TextList.vue